import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelInstagramIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.53637 5.53661C6.15086 4.92212 6.98428 4.5769 7.8533 4.5769C8.72232 4.5769 9.55575 4.92212 10.1702 5.53661C10.7847 6.1511 11.1299 6.98453 11.1299 7.85355C11.1299 8.28384 11.0452 8.70992 10.8805 9.10746C10.7159 9.505 10.4745 9.86622 10.1702 10.1705C9.86598 10.4747 9.50476 10.7161 9.10722 10.8808C8.70968 11.0454 8.2836 11.1302 7.8533 11.1302C7.42301 11.1302 6.99693 11.0454 6.59939 10.8808C6.20185 10.7161 5.84063 10.4747 5.53637 10.1705C5.2321 9.86622 4.99075 9.505 4.82608 9.10746C4.66141 8.70992 4.57666 8.28384 4.57666 7.85355C4.57666 6.98453 4.92188 6.1511 5.53637 5.53661ZM7.8533 5.7169C7.28663 5.7169 6.74317 5.94201 6.34247 6.34271C5.94177 6.74341 5.71666 7.28687 5.71666 7.85355C5.71666 8.13414 5.77193 8.41198 5.8793 8.67121C5.98668 8.93043 6.14406 9.16598 6.34247 9.36438C6.54087 9.56279 6.77642 9.72017 7.03565 9.82755C7.29487 9.93492 7.57272 9.99019 7.8533 9.99019C8.13389 9.99019 8.41173 9.93492 8.67096 9.82755C8.93019 9.72017 9.16573 9.56279 9.36414 9.36438C9.56254 9.16598 9.71993 8.93044 9.8273 8.67121C9.93468 8.41198 9.98995 8.13414 9.98995 7.85355C9.98995 7.28687 9.76484 6.74341 9.36414 6.34271C8.96344 5.94201 8.41998 5.7169 7.8533 5.7169Z"
          fill="#F7F9FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.2122 2.05113C3.01867 2.05113 2.05113 3.01868 2.05113 4.2122V11.4951C2.05113 12.6886 3.01868 13.6561 4.2122 13.6561H11.4951C12.6886 13.6561 13.6562 12.6886 13.6562 11.4951V4.2122C13.6562 3.01868 12.6886 2.05113 11.4951 2.05113H4.2122ZM0.911133 4.2122C0.911133 2.38908 2.38907 0.911133 4.2122 0.911133H11.4951C13.3182 0.911133 14.7962 2.38908 14.7962 4.2122V11.4951C14.7962 13.3182 13.3182 14.7961 11.4951 14.7961H4.2122C2.38907 14.7961 0.911133 13.3182 0.911133 11.4951V4.2122Z"
          fill="#F7F9FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0426 4.17276C12.0844 4.0935 12.108 4.00321 12.108 3.9074C12.108 3.5926 11.8528 3.3374 11.538 3.3374C11.0766 3.3374 10.7026 3.71142 10.7026 4.17276C10.7026 4.63407 11.0766 5.00812 11.538 5.00812C11.8528 5.00812 12.108 4.75292 12.108 4.43812C12.108 4.3423 12.0844 4.25201 12.0426 4.17276Z"
          fill="#F7F9FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9678 3.9074C10.9678 3.5926 11.223 3.3374 11.5378 3.3374C11.9992 3.3374 12.3731 3.71142 12.3731 4.17276C12.3731 4.63407 11.9992 5.00812 11.5378 5.00812C11.223 5.00812 10.9678 4.75292 10.9678 4.43812C10.9678 4.3423 10.9914 4.25201 11.0332 4.17276C10.9914 4.0935 10.9678 4.00321 10.9678 3.9074Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
